import { end_date } from '@organisms/stripeBanners/SummerChallengeBanner';
import { isFuture } from 'date-fns';
import { cn } from '@lib/tw';
import { useContext } from 'react';
import LanguageContext from '@lib/contexts/languageContext';

const Banner = ({ className, title, img, desc, btn_text, btn_url }) => {
  return (
    <div
      className={cn(
        'flex flex-col justify-center relative bg-[#eee] rounded lg:rounded-none',
        className
      )}
    >
      <div className="hidden lg:block absolute w-[100vw] left-0 top-0 h-full bg-[#eee] -z-1"></div>
      <a
        href={btn_url}
        className="relative z-10 block  max-w-xl lg:max-w-xs text-dark p-5 lg:pr-0 lg:py-8 lg:pl-8"
      >
        <img
          className="w-full object-cover rounded aspect-[2.22]"
          src={img}
          alt=""
        />
        <div className="py-2">
          <p className="text-base font-medium m-0 pb-1">{title}</p>
          <p className="font-light text-sm m-0">{desc}</p>
        </div>
        <span className="underline text-sm font-light">{btn_text}</span>
      </a>
    </div>
  );
};

export const SideBanner = ({ className = '' }) => {
  const lang = useContext(LanguageContext);

  if (isFuture(end_date)) {
    return (
      <Banner
        title="Summer Yoga Challenge"
        desc="30 dagar sommaryoga – anmäl dig till utmaningen."
        img={'/static/SYC-Meny.webp'}
        btn_text="Klicka här!"
        btn_url="/se/challenges/summer-yoga-challenge-2025/overview"
        className={className}
      />
    );
  }

  return (
    <Banner
      title="Friskvårdsbidrag"
      desc="Med Yogobe Flex kan du använda hela friskvårdsbidraget – till sista kronan!"
      img={'/static/play-menu-wellness.webp'}
      btn_text="Läs mer"
      btn_url={`/${lang}/friskvardsbidrag`}
      className={className}
    />
  );
};
